import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { bookCatalog } from '../data/books';
import { solverBooks } from '../data/solverBooks';
import { resolveDisplayImageUrl } from '../lib/assets';

export default function SolverPage() {
  return (
    <>
      <Header />
      <main className="mx-auto max-w-6xl space-y-7 px-4 py-8 sm:px-6">
        <section className="max-w-5xl border-l-4 border-brand-magenta bg-white/85 p-6 shadow-xl shadow-slate-200/60 sm:p-7">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-brand-magenta">
            Solver
          </p>
          <h1 className="mt-3 text-3xl font-semibold leading-tight text-slate-900 md:text-[2.4rem]">
            Choose a book solver
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-600 md:text-base">
            Stuck on a puzzle? Enter the access code from the last page of your book, pick a puzzle number, and step through the solution one move at a time.
          </p>
        </section>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {solverBooks.map((book) => {
            const coverSrc = resolveDisplayImageUrl(book.coverUrl);
            const comingSoon = bookCatalog.find((entry) => entry.id === book.id)?.comingSoon;

            return (
              <Link
                key={book.id}
                to={`/solver/${book.id}`}
                className="group rounded-lg border border-slate-200 bg-white p-3 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-brand-cyan hover:shadow-lg focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-cyan/30"
              >
                <div className="relative aspect-[4/5] rounded-md bg-slate-50 p-2">
                  {coverSrc ? (
                    <img
                      src={coverSrc}
                      alt={book.title}
                      className="h-full w-full object-contain"
                    />
                  ) : (
                    <div className="flex h-full items-center justify-center px-2 text-center text-sm font-semibold text-slate-500">
                      {book.title}
                    </div>
                  )}
                  {comingSoon && (
                    <span className="absolute right-2 top-2 whitespace-nowrap rounded-full bg-brand-magenta px-3 py-1 text-xs font-semibold text-white shadow-md">
                      Coming soon
                    </span>
                  )}
                </div>
                <div className="mt-3">
                  <h2 className="text-sm font-semibold leading-5 text-slate-900">
                    {book.title}
                  </h2>
                  <p className="mt-1 text-xs font-medium uppercase tracking-[0.16em] text-slate-400">
                    {book.puzzleCount} puzzles
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </main>
    </>
  );
}
